import { BaseColumn, CastNode } from 'types/transformation/types/nodes'
import DataType from 'types/transformation/enums/DataType'

export const getChangeColumn = (
  node: CastNode,
  leftColumn: BaseColumn
): BaseColumn => {
  return {
    id: leftColumn.id,
    name: leftColumn.name,
    reference_node: node.id,
    reference_node_index: node.index,
    type: node.change_column?.type ?? DataType.STRING
  }
}
